const menu = {
    list() {
        return [
            {
                "backMenu":[
                    {
                        "child":[
                            {
                                "buttons":[
                                    "查看",
                                    "新增",
                                    "修改",
                                    "删除"
                                ],
                                "menu":"组织岗位管理",
                                "menuJump":"列表",
                                "tableName":"sysOrg"
                            },
                            {
                                "buttons":[
                                    "查看",
                                    "新增",
                                    "修改",
                                    "删除"
                                ],
                                "menu":"角色管理",
                                "menuJump":"列表",
                                "tableName":"sysRole"
                            },
                            {
                                "buttons":[
                                    "查看",
                                    "新增",
                                    "修改",
                                    "删除"
                                ],
                                "menu":"用户管理",
                                "menuJump":"列表",
                                "tableName":"users"
                            }
                        ],
                        "menu":"组织管理"
                    },
                    {
                        "child":[
                            {
                                "buttons":[
                                    "查看",
                                    "新增",
                                    "修改",
                                    "删除"
                                ],
                                "menu":"煤种数据",
                                "menuJump":"列表",
                                "tableName":"cocalTemplate"
                            },
                            {
                                "buttons":[
                                    "查看",
                                    "新增",
                                    "修改",
                                    "删除"
                                ],
                                "menu":"港口数据维护",
                                "menuJump":"列表",
                                "tableName":"port"
                            }
                        ],
                        "menu":"煤种数据"
                    },
                    {
                        "child":[
                            {
                                "buttons":[
                                    "查看",
                                ],
                                "menu":"单品种煤源排行",
                                "menuJump":"列表",
                                "tableName":"cocalRankingList"
                            },
                            {
                                "buttons":[
                                    "查看",
                                ],
                                "menu":"车板价排行",
                                "menuJump":"列表",
                                "tableName":"cocalSweepList"
                            },
                            {
                                "buttons":[
                                    "查看",
                                ],
                                "menu":"平仓价排行",
                                "menuJump":"列表",
                                "tableName":"cocalPingcangList"
                            }
                        ],
                        "menu":"排行管理"
                    }
                    /*,{
                        "child":[
                            {
                                "buttons":[
                                    "查看",
                                    "新增",
                                    "修改",
                                    "删除"
                                ],
                                "menu":"用户管理",
                                "menuJump":"列表",
                                "tableName":"users"
                            }
                        ],
                        "menu":"用户管理"
                    }*/

                    ,{
                        "child":[
                            {
                                "buttons":[
                                    "查看",
                                    "新增",
                                    "删除",
                                    "修改"
                                ],
                                "menu":"组织类型维护",
                                "menuJump":"列表",
                                "tableName":"dictionaryOrgType"
                            },
                            {
                                "buttons":[
                                    "查看",
                                    "新增",
                                    "删除",
                                    "修改"
                                ],
                                "menu":"菜单按钮类型维护",
                                "menuJump":"列表",
                                "tableName":"dicitonaryMenuBtn"
                            },
                            {
                                "buttons":[
                                    "查看",
                                    "新增",
                                    "删除",
                                    "修改"
                                ],
                                "menu":"煤种类型维护",
                                "menuJump":"列表",
                                "tableName":"dicitonaryCocalType"
                            }
                        ],
                        "menu":"基础数据管理"
                    }
                    ,{
                        "child":[
                            {
                                "buttons":[
                                    "查看",
                                    "编辑",
                                    "新增",
                                ],
                                "menu":"咨询管理",
                                "menuJump":"列表",
                                "tableName":"consult"
                            },{
                                "buttons":[
                                    "查看",
                                    "编辑",
                                    "新增",
                                ],
                                "menu":"菜单管理",
                                "menuJump":"列表",
                                "tableName":"menu"
                            },
                        ],
                        "menu":"系统配置"
                    }
                ],
                "frontMenu":[],
                "hasBackLogin":"是",
                "hasBackRegister":"否",
                "hasFrontLogin":"否",
                "hasFrontRegister":"否",
                "roleName":"管理员",
                "tableName":"users"
            },

        ]
    }
}
export default menu;
